"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE_CHANGE_COMPLETE = exports.ROUTE_CHANGE_START = void 0;
exports.ROUTE_CHANGE_START = 'routeChangeStart';
exports.ROUTE_CHANGE_COMPLETE = 'routeChangeComplete';
